export enum LinkSize {
    SMALL = 'small',
    MEDIUM = 'medium',
}